import { render, staticRenderFns } from "./StatusBar.vue?vue&type=template&id=3454f192&scoped=true"
import script from "./StatusBar.vue?vue&type=script&lang=js"
export * from "./StatusBar.vue?vue&type=script&lang=js"
import style0 from "./StatusBar.vue?vue&type=style&index=0&id=3454f192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3454f192",
  null
  
)

export default component.exports